"use client";

import { useEffect, useState } from "react";
import type { PendingPaymentData } from "../types/local-storage.type";
import { getPendingPayment, pendingPaymentEventName } from "../utils";

// The payment the user started and has not settled yet, as React state.
// Follows setPendingPayment/clearPendingPayment through their change event, so
// effects can wait for the payment to settle. Read synchronously on mount:
// effects of the same commit (the finalized-cart handling) must already see
// it, a value that arrives one render later would let them run without it.
// On the server there is no storage and the value is null.
export const usePendingPayment = () => {
  const [pendingPayment, setPendingPayment] =
    useState<PendingPaymentData | null>(() => getPendingPayment());

  useEffect(() => {
    const sync = () => setPendingPayment(getPendingPayment());

    window.addEventListener(pendingPaymentEventName, sync);

    return () => {
      window.removeEventListener(pendingPaymentEventName, sync);
    };
  }, []);

  return pendingPayment;
};
